//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import StockControlMixin from './StockControlMixin.js'
import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import StockControlRecordGeneralInfo from './StockControlRecordGeneralInfo.vue'

export default {
  name: 'StockControlRecord',
  components: {
    StockConfigurationDepartmentSelector,
    StockControlRecordGeneralInfo
  },
  // mixins: [StockControlMixin],
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      departmentSelectorConfig: {
        loading: false,
        defaultDepartmentId: this.record.department && this.record.department.id || null,
        departmentId: null,
        department: null,
        departments: [],
        hasChanges: false,
        readonly: true
      },

      tools: [],
      store: null,

      loading: false
    }
  },
  computed: {
    stockControlRecord: function () {
      return this.record || null
    },
    hasEditAccess: function () {
      return !this.readonly && this.$d_hasOperation('stockAccessoryControl')
    }
  },
  watch: {
  },
  created: function () {
  },
  methods: {
  }
}

